import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import BpmnEditorPanel from './BpmnEditorPanel';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function BpmnEditorDialog(props) {
    const { open, setOpen, rootProcesso, stylePacote, action } = props;
    const childRef = React.useRef(null);

    const handleCallChildFunction = () => {
        if (childRef.current) {
            childRef.current.childFunction(); // Call the exposed function
            const proc = childRef.current.getProcesso();
            childRef.current.salva();

// setTimeout(() => {
    if( action)action();
// }, 3000);
            
        }
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        handleCallChildFunction();
        setOpen(false);
    };

    return (
        <React.Fragment>

            <Dialog
                fullScreen
                open={open}
                onClose={handleClose}
                slots={{
                    transition: Transition,
                }}
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            {rootProcesso ? rootProcesso.pacote + "." + rootProcesso.nome : ''}
                        </Typography>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
              save
            </Button> */}
                    </Toolbar>
                </AppBar>
                <BpmnEditorPanel
                    rootProcesso={rootProcesso}
                    stylePacote={stylePacote}
                    ref={childRef}
                />
            </Dialog>
        </React.Fragment>
    );
}
